// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__RLKSB","text":"style_text__6fgqo","reason":"style_reason__zlOlY","reason_list":"style_reason_list__LVdCF","error":"style_error__0FTr5"};